import { CREDIT } from 'src/config/paymentTypes'

export default {

  client: {
    name: ''
  },
  product: null,
  job: {
    title: '',
    organisation_name: '',
    client_id: '',
    product_id: '',
    text_type: 'own',
    text_own: '',
    text_html: '',
    po_number: '',
    text_platform: {
      job: '',
      function: '',
      company: '',
      offer: '',
    },
    payment_type_id: null,
    city: '',
    postal_code: '',
    country_code: '',
    apply_email: '',
    recruiter_phone_country: '',
    recruiter_phone: '',
    location_type: 'city',
    image: null,
    apply_url: '',
    apply_type: 'jobBoard',
    from: '',
    till: '',
    pixel_url: '',
    function_description: '',
    function_requirements: '',
    company_description: '',
    salary_year: 0,
    offer: '',
    recruiter_name: '',
    recruiter_email: '',
    recruiter_website: '',
    segments: {
      function_category: [],
      industry: [],
      career_level: [],
      education: [],
      contract: [],
      time: []
    }
  },
  jobBoards: [],
  payment: {

  }

}
